import React from 'react'
import { Dialog, Icon, Button } from 'bs-unified-ui'
import { Box, useTheme, Typography, useMediaQuery } from '@mui/material'

interface UnifiedErrorDialogProps {
  icon?: string
  title: string
  message: string | React.ReactNode
  maxWidth: number | string
  okText?: string
  children?: Function | string | React.ReactNode
  open: boolean
  onOk?: any
  onClose?: any
  closeOnClick?: boolean
  renderIcon?: any
}

const UnifiedErrorDialog = ({
  icon,
  title = '',
  message = '',
  maxWidth = 871,
  okText = 'OK',
  children,
  open,
  onOk = () => {},
  onClose,
  closeOnClick = true,
  renderIcon,
  ...props
}: UnifiedErrorDialogProps) => {
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down(1024))

  const handleOk = () => {
    if (closeOnClick) {
      onOk()
      onClose()
    } else {
      onOk()
    }
  }

  return (
    <Dialog
      open={open}
      maxWidth={maxWidth}
      disableBackdropClick={false}
      onClose={() => {}}
      placement="bottom"
      bgColorContent="#FFEB00"
      sx={{
        ...(isTablet ? {} : { marginLeft: 32 }),
        '& .MuiPaper-root': {
          m: 2,
          zIndex: 10,
        },
        '& .MuiDialogContent-root': {
          paddingLeft: 3,
        },
      }}
    >
      {children ? (
        <>{children}</>
      ) : (
        <Box
          sx={{
            display: 'flex',
            flex: 1,
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {renderIcon ? (
              renderIcon
            ) : (
              <Icon
                name={icon || 'alert'}
                type="fill"
                isCustom={false}
                size={16}
              />
            )}
            <Typography variant="fs16" sx={{ ml: 1 }}>
              {title}
            </Typography>
          </Box>
          <Box sx={{ width: 'calc(100% - 240px)' }}>
            <Typography variant="fs14">
              {typeof message === 'string'
                ? message.split('\n').map((line, idx) => (
                    <React.Fragment key={idx}>
                      {line}
                      <br />
                    </React.Fragment>
                  ))
                : message}
            </Typography>
          </Box>
          <Button variant="contained" onClick={handleOk}>
            {okText}
          </Button>
        </Box>
      )}
    </Dialog>
  )
}

export default UnifiedErrorDialog
